import { IAudioSurah } from '../interfaces/i-audio-surah';
import { IPlaylist } from '../interfaces/i-playlist';
import { AudioSurah } from './audio-surah';

export class Playlist {
  id: string;
  items: string[];
  name: string;
  ownerID: string;
  ownerImage: string;
  ownerName: string;
  audioSurahsPure: IAudioSurah[];
  audioSurahs: AudioSurah[];

  constructor(data: IPlaylist) {
    this.id = data.id;
    this.items = data.items;
    this.name = data.name;
    this.ownerID = data.ownerID;
    this.ownerImage = data.ownerImage;
    this.ownerName = data.ownerName;
    this.audioSurahsPure = data.audioSurahs ? data.audioSurahs : [];
    this.audioSurahs = data.audioSurahs
      ? data.audioSurahs.map((audioSurah) => new AudioSurah(audioSurah))
      : [];
  }
}
